/** Full UTC days left until VIP expiry (ceil). Null if unknown date. */
export function getVipDaysRemaining(vipExpiresAtUtc: string | null | undefined): number | null {
  if (vipExpiresAtUtc == null || vipExpiresAtUtc === '') return null;
  const end = new Date(vipExpiresAtUtc).getTime();
  if (Number.isNaN(end)) return null;
  const diffMs = end - Date.now();
  if (diffMs <= 0) return 0;
  return Math.ceil(diffMs / (24 * 60 * 60 * 1000));
}
